export default "__VITE_ASSET__D95zsUSV__"